import { useEffect, useState } from 'react';

export default function useHasScrolledPast(
  elementRef: React.RefObject<HTMLElement>
) {
  const [hasScrolledPast, setHasScrolledPast] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;

      const elementLocationInView = entry.boundingClientRect.y;
      const isIntersecting = entry.isIntersecting;

      setHasScrolledPast(elementLocationInView < 0 || isIntersecting);
    });

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  });

  return hasScrolledPast;
}
